import cookies from 'js-cookie';
import yousersjs from '@yola/yousersjs';
import Configuration from '../modules/configuration';
import User from '../modules/user';
import getCurrentLocale from './current-locale';
import generatePathWithLocale from './generate-path-with-locale';
import getLocaleFromPathname from './get-locale-from-path';
import setUserLocale from './set-user-locale';

const initializeLocale = () => {
  const config = Configuration.get();
  const user = User.get();
  const referrerUrl = document.referrer && new URL(document.referrer);
  const localeCookieName = config.getLocaleCookieName();
  const localeFromCookie = cookies.get(localeCookieName);
  const localeFromReferrer = referrerUrl?.pathname && getLocaleFromPathname(referrerUrl.pathname);
  const currentLocale = getCurrentLocale();
  const isReferredFromYolaCms = referrerUrl?.origin === window.location.origin;
  const isLocaleWasChangedOnYolaCms =
    isReferredFromYolaCms &&
    localeFromReferrer !== currentLocale &&
    localeFromCookie !== currentLocale;

  if (!localeFromCookie || isLocaleWasChangedOnYolaCms) {
    setUserLocale(currentLocale);
    return;
  }

  if (localeFromCookie !== currentLocale) {
    if (user.isAuthenticated()) {
      yousersjs
        .preferences()
        .get()
        .then((response) => {
          const { locale: localeFromPreferences } = response.body;
          const locale = localeFromPreferences || localeFromCookie;

          if (locale !== localeFromCookie) {
            setUserLocale(locale);
          }

          window.location.replace(generatePathWithLocale(locale));
        });
    } else {
      window.location.replace(generatePathWithLocale(localeFromCookie));
    }
  }
};

export default initializeLocale;
